"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesDateStringContainOffset = doesDateStringContainOffset;
exports.getLocalDateTime = getLocalDateTime;
exports.getDate = getDate;
exports.getCalendarDateTime = getCalendarDateTime;
exports.getShortDate = getShortDate;
exports.getTimeRecordDate = getTimeRecordDate;
exports.convertISODateToHumanReadableDate = convertISODateToHumanReadableDate;
exports.convertISODateToShortDate = convertISODateToShortDate;
exports.convertISODateToEventDate = convertISODateToEventDate;
exports.convertISODateToPardotDate = convertISODateToPardotDate;
exports.getPastDate = getPastDate;
const dayjs_1 = __importDefault(require("dayjs"));
const calendar_1 = __importDefault(require("dayjs/plugin/calendar"));
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(calendar_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(utc_1.default);
function doesDateStringContainOffset(date) {
    return date.endsWith('Z') || (/[+-]\d\d:\d\d$/u).test(date);
}
function getLocalDateTime(date) {
    return doesDateStringContainOffset(date) ? (0, dayjs_1.default)(date) : (0, dayjs_1.default)(`${date}+00:00`).utc(true);
}
function getDate(date) {
    const trimmedDate = date.includes('T') ? date.slice(0, date.indexOf('T')) : date;
    const utcDate = dayjs_1.default.utc(trimmedDate);
    return utcDate;
}
function getCalendarDateTime(date) {
    return getLocalDateTime(date).format('YYYY-MM-DD h:mma');
}
function getShortDate(date) {
    return getLocalDateTime(date).format('M/D/YY');
}
function getTimeRecordDate(date) {
    return getLocalDateTime(date).format('M/D/YY h:mm a');
}
function convertISODateToHumanReadableDate(date) {
    return getLocalDateTime(date).format('dddd, MMMM Do YYYY, h:mm:ss a');
}
function convertISODateToShortDate(date) {
    return getLocalDateTime(date).format('MMM D YYYY, h:mm:ss a');
}
function convertISODateToEventDate(date) {
    return getLocalDateTime(date).format('M/D/YYYY, h:mm:ss A z');
}
function convertISODateToPardotDate(date) {
    return getLocalDateTime(date).format('MMM D, YYYY h:mm a');
}
function getPastDate(daysAgo) {
    return (0, dayjs_1.default)().startOf('day')
        .subtract(daysAgo, 'day')
        .format('YYYY-MM-DD');
}
//# sourceMappingURL=lib.js.map